import { InfoBar } from '@design-system/info-bar';
import React, { FC, useEffect, useRef } from 'react';

import { TopBarProps } from './models';

const TopBar: FC<TopBarProps> = ({
  className,
  messages,
  ariaLabels,
  soloMode,
  intervalTime,
  showInfoBar,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const mainNode = document.querySelector('#main');
    mainNode?.parentNode?.insertBefore(ref.current, mainNode);
  }, []);

  return showInfoBar ? (
    <InfoBar
      soloMode={soloMode}
      className={className}
      intervalTime={intervalTime}
      ref={ref}
      messages={messages}
      ariaLabels={{
        play: ariaLabels?.playButtonAriaLabel!,
        pause: ariaLabels?.pauseButtonAriaLabel!,
        arrowRight: ariaLabels?.nextButtonAriaLabel!,
        arrowLeft: ariaLabels?.previousButtonAriaLabel!,
      }}
    />
  ) : null;
};

export default TopBar;
